import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import RiskAssessmentShareSettings from 'components/riskRegister/riskAssessmentShareSettings/components/RiskAssessmentShareSettings';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <AppWrapper {...contextProps}>
      <RiskAssessmentShareSettings {...wrappedProps} />
    </AppWrapper>
  );
}
